import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { MainLayout } from '@/components/layout/MainLayout';
import { PageLoader } from '@/components/feedback/PageLoader';

const HomePage = lazy(() => import('@/pages/HomePage').then((m) => ({ default: m.HomePage })));
const PropertiesPage = lazy(() => import('@/pages/PropertiesPage').then((m) => ({ default: m.PropertiesPage })));
const PropertyDetailPage = lazy(() => import('@/pages/PropertyDetailPage').then((m) => ({ default: m.PropertyDetailPage })));
const ProjectsPage = lazy(() => import('@/pages/ProjectsPage').then((m) => ({ default: m.ProjectsPage })));
const ProjectDetailPage = lazy(() => import('@/pages/ProjectDetailPage').then((m) => ({ default: m.ProjectDetailPage })));
const ServicesPage = lazy(() => import('@/pages/ServicesPage').then((m) => ({ default: m.ServicesPage })));
const SellOrRentPage = lazy(() => import('@/pages/SellOrRentPage').then((m) => ({ default: m.SellOrRentPage })));
const LegalRealEstatePage = lazy(() => import('@/pages/LegalRealEstatePage').then((m) => ({ default: m.LegalRealEstatePage })));
const LocationsPage = lazy(() => import('@/pages/LocationsPage').then((m) => ({ default: m.LocationsPage })));
const LocationDetailPage = lazy(() => import('@/pages/LocationDetailPage').then((m) => ({ default: m.LocationDetailPage })));
const AboutPage = lazy(() => import('@/pages/AboutPage').then((m) => ({ default: m.AboutPage })));
const TeamPage = lazy(() => import('@/pages/TeamPage').then((m) => ({ default: m.TeamPage })));
const TeamMemberPage = lazy(() => import('@/pages/TeamMemberPage').then((m) => ({ default: m.TeamMemberPage })));
const GuidesPage = lazy(() => import('@/pages/GuidesPage').then((m) => ({ default: m.GuidesPage })));
const GuideDetailPage = lazy(() => import('@/pages/GuideDetailPage').then((m) => ({ default: m.GuideDetailPage })));
const FAQPage = lazy(() => import('@/pages/FAQPage').then((m) => ({ default: m.FAQPage })));
const ContactPage = lazy(() => import('@/pages/ContactPage').then((m) => ({ default: m.ContactPage })));
const PrivacyPage = lazy(() => import('@/pages/PrivacyPage').then((m) => ({ default: m.PrivacyPage })));
const TermsPage = lazy(() => import('@/pages/TermsPage').then((m) => ({ default: m.TermsPage })));
const CookiesPage = lazy(() => import('@/pages/CookiesPage').then((m) => ({ default: m.CookiesPage })));
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })));

function LazyPage({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}

export function AppRouter() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route index element={<LazyPage><HomePage /></LazyPage>} />
        <Route path="propiedades" element={<LazyPage><PropertiesPage /></LazyPage>} />
        <Route path="propiedades/venta" element={<LazyPage><PropertiesPage operation="sale" /></LazyPage>} />
        <Route path="propiedades/alquiler" element={<LazyPage><PropertiesPage operation="rent" /></LazyPage>} />
        <Route path="propiedad/:slug" element={<LazyPage><PropertyDetailPage /></LazyPage>} />
        <Route path="proyectos" element={<LazyPage><ProjectsPage /></LazyPage>} />
        <Route path="proyecto/:slug" element={<LazyPage><ProjectDetailPage /></LazyPage>} />
        <Route path="servicios" element={<LazyPage><ServicesPage /></LazyPage>} />
        <Route path="vende-o-alquila" element={<LazyPage><SellOrRentPage /></LazyPage>} />
        <Route path="asesoria-legal-inmobiliaria" element={<LazyPage><LegalRealEstatePage /></LazyPage>} />
        <Route path="zonas" element={<LazyPage><LocationsPage /></LazyPage>} />
        <Route path="zona/:slug" element={<LazyPage><LocationDetailPage /></LazyPage>} />
        <Route path="nosotros" element={<LazyPage><AboutPage /></LazyPage>} />
        <Route path="equipo" element={<LazyPage><TeamPage /></LazyPage>} />
        <Route path="equipo/:slug" element={<LazyPage><TeamMemberPage /></LazyPage>} />
        <Route path="guias" element={<LazyPage><GuidesPage /></LazyPage>} />
        <Route path="guias/:slug" element={<LazyPage><GuideDetailPage /></LazyPage>} />
        <Route path="preguntas-frecuentes" element={<LazyPage><FAQPage /></LazyPage>} />
        <Route path="contacto" element={<LazyPage><ContactPage /></LazyPage>} />
        <Route path="privacidad" element={<LazyPage><PrivacyPage /></LazyPage>} />
        <Route path="terminos" element={<LazyPage><TermsPage /></LazyPage>} />
        <Route path="cookies" element={<LazyPage><CookiesPage /></LazyPage>} />
        <Route path="404" element={<LazyPage><NotFoundPage /></LazyPage>} />
        <Route path="*" element={<LazyPage><NotFoundPage /></LazyPage>} />
      </Route>
    </Routes>
  );
}
